import formats from '../../api/formats'
import dialogs from '../common/dialogs'
import server from '../../api/server.js'
import store from '../../store'
import forms from '../common/forms.js'
import vClientSelector from './ClientSelector'
import clientMailbox from './ClientMailbox.js'

export default {
  createStrategy (cxt, type) {
    switch (type) {
      case 'CLIENT_MAILBOX': {
        return clientMailbox.createStrategy(cxt)
      }
    }
  },
  getCachedRefs (refcodes, cb) {
    store.dispatch('getCachedRefs', {refcodes: refcodes}).then(
            (data) => cb(data),
            () => {}
    )
  },
  convertInnToRefCode (inns) {
    return store.dispatch('convertInnToRefCode', {inns: inns})
  },
  getBriefCompanies (refCodes) {
    return store.dispatch('getBriefCompaniesByRefCode', {refCodes: refCodes})
  },
  selectRef (cxt, onSelect, getQuery, favorite, radio, partner) {
    const cbSelect = (refCodes) => {
      console.log('cbSelect', refCodes)
      if (radio) {
        return this.getBriefCompanies(refCodes)
        .then((data) => {
          console.log('selectRef', data)
          onSelect(data)
        })
      }
      return onSelect(refCodes)
    }
    dialogs.register('v-client-selector', vClientSelector)
    var fullscreen = store.getters.getIsMobile
    var comp = { template: `
      <v-client-selector
      v-on:close="$emit('close')"
      v-on:input="onSelect"
      :query="getQuery()"
      :fullscreen="fullscreen"
      :favorite="favorite"
      :radio="radio"
      :partner="partner"
      refCode
      ></v-client-selector>
      `,
      data () {
        return {
          fullscreen: fullscreen,
          onSelect: cbSelect,
          getQuery: getQuery,
          favorite: favorite,
          radio: radio,
          partner: partner
        }
      }
    }
    dialogs.modal(comp)
  },
  getHumanProps (inn) {
    return new Promise((resolve, reject) => {
      const cbError = (e) => {
        store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о физическом лице из ЕГРЮЛ '})
      }
      const cb = (data) => resolve(data)
      server.openApiGet(
        '/openapi/humans/' + inn,
        cb,
        cbError)
    })
  },
  getHoldersByCompany (companyRefCode) {
    console.log('getHoldersByCompany', companyRefCode)
    return new Promise((resolve, reject) => {
      const cbError = (e) => {
        store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об участниках из ЕГРЮЛ '})
      }
      const cb = (data) => resolve(data)
      if (!formats.isRefCode(companyRefCode)) {
        store.commit('setErrorStatus', {error: `Неверный код компании [${companyRefCode}] `, context: 'Ошибка клиента при получении информации об участниках из ЕГРЮЛ '})
      }
      server.openApiGet(
        '/openapi/companies/' + formats.splitRefCode(companyRefCode).code + '/holders',
        cb,
        cbError)
    })
  },
  openClientMailbox (itemId, clientId, clientNameShort) {
    return new Promise((resolve, reject) => {
      let strategy = this.createStrategy(null, 'CLIENT_MAILBOX')
      strategy.setParentProps({clientId: clientId, clientNameShort: clientNameShort})
      forms.openFormStg(strategy, itemId).then(data => resolve(data))
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/client/index.js